import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import styles from "./EpisodeListTable.module.css";
import { isTenantVet } from "../../services/tenantService";

const PatientEpisodesListHeader: React.FC<any> = () => {
  return (
    <Box mx={[0, 3]} mb={0.2} px={2} py={1} className={styles.headerRow} sx={{ display: { xs: "none", md: "block" } }}>
      <Grid container alignItems="flex-start">
        <Grid
          size={{
            xs: "auto",
            sm: "auto",
            md: "auto",
          }}
        >
          <Box mr={2} width={28}>
            &nbsp;
          </Box>
        </Grid>
        <Grid
          container
          size={{
            xs: "grow",
            sm: "grow",
            md: "grow",
          }}
        >
          <Grid
            size={{
              xs: "grow",
              sm: "grow",
              md: "grow",
              lg: 2,
            }}
          >
            <Typography variant="caption" color="grey.100">
              {isTenantVet() ? "Owner, Animal/Herd" : "Surname, Given name(s)"}
            </Typography>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 12,
              lg: 1,
            }}
          >
            <Typography variant="caption" color="grey.100">
              Birth date
            </Typography>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 12,
              lg: 1,
            }}
          >
            <Typography variant="caption" color="grey.100">
              Lab Number
            </Typography>
          </Grid>
          <Grid
            size={{
              xs: 12,
              lg: "grow",
            }}
          >
            <Typography variant="caption" color="grey.100">
              Panels
            </Typography>
          </Grid>
          <Grid
            size={{
              xs: 12,
              lg: 1,
            }}
          >
            <Typography variant="caption" color="grey.100">
              Referrer
            </Typography>
          </Grid>
          <Grid
            size={{
              sm: 2,
              md: 2,
              lg: 1,
            }}
          >
            <Typography align="right" variant="caption" color="grey.100">
              Reported
            </Typography>
          </Grid>
          <Grid
            size={{
              sm: 2,
              md: 2,
              lg: 1,
            }}
          >
            <Typography align="right" variant="caption" color="grey.100">
              Status
            </Typography>
          </Grid>
          <Grid
            size={{
              sm: 1,
              md: 1,
              lg: 1,
            }}
          >
            <Box display={"flex"} flexDirection={"row"} justifyContent={"right"}>
              <Typography align="right" variant="caption" color="grey.100">
                Print
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default PatientEpisodesListHeader;
